import { lazy, Suspense, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import Hero from "@/components/Hero";
import Navigation from "@/components/Navigation";
import TrustStrip from "@/components/TrustStrip";
import BelowFoldSkeleton from "@/components/BelowFoldSkeleton";
import { authService } from "@/lib/api";

const LandingBelowFold = lazy(() => import("./LandingBelowFold"));

const Index = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const allowLanding = searchParams.get("allow") === "true";

  useEffect(() => {
    // Native app: skip marketing by default; optional ?allow=true opens the public site.
    if (Capacitor.isNativePlatform() && !allowLanding) {
      if (authService.isAuthenticated()) {
        const user = authService.getUser();
        if (user) {
          if (user.role === "admin") {
            navigate("/admin");
          } else {
            navigate("/customer");
          }
        }
      } else {
        navigate("/auth");
      }
    }
  }, [navigate, allowLanding]);

  // Start the below-fold chunk right after first paint (does not block LCP).
  useEffect(() => {
    const run = () => {
      void import("./LandingBelowFold");
    };
    if (typeof globalThis.requestIdleCallback === "function") {
      const id = globalThis.requestIdleCallback(run, { timeout: 2500 });
      return () => globalThis.cancelIdleCallback(id);
    }
    const t = globalThis.setTimeout(run, 0);
    return () => globalThis.clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden w-full">
      <Navigation />

      <Hero />

      <TrustStrip />

      <Suspense fallback={<BelowFoldSkeleton />}>
        <LandingBelowFold />
      </Suspense>
    </div>
  );
};

export default Index;
